var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "custom-navbar-extra-options" },
    [
      _c(
        "VButton",
        {
          ref: "button",
          on: {
            mouseover: function ($event) {
              return _vm.loadNavbarSettings()
            },
            click: function ($event) {
              return _vm.toggleNavbarSettings()
            },
          },
        },
        [
          _vm._v("\n    布局设置"),
          _c("VIcon", { attrs: { icon: "right-arrow", size: 16 } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }